import * as Yup from "yup";

const phoneRegExp=/^(?:\+54|549)?0?(11|[23689]\d)\d{7}$/

export function initialValues(company) {
  return {
    name: company?.name || "",
    cuit: company?.cuit || "",
    address: company?.address || "",
    phone: company?.phone || "",
    email: company?.email || "",
    logo: company?.logo || "",
    // Sin valor: contratado el producto de esta app; el de la otra hay que marcarlo.
    products: {
      sustentable: company?.products?.sustentable !== false,
      sh: company?.products?.sh === true,
    },
  };
}

export function validationSchema(company) {
  return Yup.object({
    name: Yup.string().required("El campo es requerido"),
    cuit: Yup.string().required("El campo es requerido"),
    address: Yup.string().required("El campo es requerido"),
    phone: Yup.string().required("El campo es requerido"),
    //.matches(phoneRegExp, 'El número de teléfono no es válido'),
    email: Yup.string().email("Ingrese un Correo Electrónico válido").required("El campo es requerido"),
  });
}
